
 <section class="flex justify-center items-center w-full h-screen">
    <div class="flex flex-row items-center justify-center lg:w-3/4">
        <div class="text-center flex flex-col lg:w-1/2 w-full mx-4 md:mx-12 lg:mx-0">

            <!-- <div class="flex justify-center mb-4 max-md:hidden">
                <img class="w-60" [src]="logo" alt="logo" loading="lazy">
            </div> -->

            <!-- Title -->
            <div class="mt-8 text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight">
                Log in to your account
            </div>
            <div class="flex items-baseline mt-0.5 font-medium justify-center">
                <div>Please enter your details.</div>
            </div>

            <!-- Alert -->
            <fuse-alert class="mt-8" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false" [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{alert.message}}
            </fuse-alert>

            <!-- Sign in form -->
            <form class="mt-8" [formGroup]="signInForm" #signInNgForm="ngForm">

                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>Email address</mat-label>
                    <input id="username" matInput [formControlName]="'Username'">
                    <mat-error *ngIf="signInForm.get('Username').hasError('required')">
                        Email address is required
                    </mat-error>
                    <mat-error *ngIf="signInForm.get('Username').hasError('email')">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>

                <!-- Password field -->
                <mat-form-field class="w-full">
                    <mat-label>Password</mat-label>
                    <input id="password" matInput type="password" [formControlName]="'Password'" #passwordField>
                    <button mat-icon-button type="button"
                        (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                        matSuffix>
                        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                            [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                            [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
                    </button>
                    <mat-error>
                        Password is required
                    </mat-error>
                </mat-form-field>

                <!-- Actions -->
                <div class="inline-flex items-center justify-between w-full mt-1.5">
                    <mat-checkbox class="-ml-2" [color]="'primary'" [formControlName]="'rememberMe'">
                        Remember me
                    </mat-checkbox>
                    <a class="text-md font-medium text-primary-500 hover:underline"
                        [routerLink]="['/forgot-password']">Forgot password?
                    </a>
                </div>

                <!-- Submit button -->
                <button class="w-full mt-6" mat-flat-button [color]="'primary'" [disabled]="!signInForm.valid"
                    (click)="signIn()">
                    <span *ngIf="!signInForm.disabled">
                        Log in
                    </span>
                    <mat-progress-spinner *ngIf="signInForm.disabled" [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </button>

                <!-- Single sign-on buttons -->
                <div class="flex items-center mt-8 space-x-4">
                    <button
                        class="flex-auto text-primary bg-primary-100 border border-primary-100 hover:bg-primary hover:text-white"
                        (click)="openOTPDialog(otpDialog)" mat-flat-button>
                        <span>
                            Log in with OTP?
                        </span>
                    </button>
                </div>
                <div class="flex items-baseline mt-4 font-medium text-black justify-center">
                    <div>Don't have an account?</div>
                    <a class="ml-2 font-bold text-primary hover:underline" [routerLink]="['/sign-up']">Sign Up
                    </a>
                </div>
                <div class="flex items-baseline mt-4 text-black justify-center">
                    <a class="text-sm text-primary">Version</a>
                    <p class="text-sm ml-2">0.0.9</p>
                </div>
            </form>
        </div>
        <!-- <div
            class="hidden lg:block w-1/2 ">
            <img class=" " [src]="image">
        </div> -->
    </div>
 
</section>
 

<ng-template #otpDialog>

    <div *ngIf="!showOTPInput">
        <h1 class="text-2xl font-bold pb-8">Request your Login OTP</h1>

        <p class="pb-8">
            Please enter your mobile number below. We will send an OTP (One Time Pin) to the mobile number associated
            with your account username.
        </p>

        <mat-form-field class="w-full">
            <mat-label>Phone Number</mat-label>
            <input matInput (keyup)="phoneNumberChange($event)" type="tel">
        </mat-form-field>

        <mat-form-field *ngIf="showEmailInput" class="w-full">
            <mat-label>Email</mat-label>
            <input matInput (keyup)="emailChange($event)" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                type="email">
        </mat-form-field>

        <p class="py-2 text-red-500" *ngIf="accountAvailable?.IsAvailable && accountAvailable?.Type == 'phoneNumber'">
            Username is not registered to login via OTP. <br> <a class="cursor-pointer text-black"
                (click)="registerMobileUsername()">Register now?</a>
        </p>

        <p class="py-2 text-red-500" *ngIf="accountAvailable?.IsAvailable && accountAvailable?.Type == 'email'">
            Email not found, please <a class="cursor-pointer text-black" (click)="goToSignUp()">register</a> an account.
        </p>

        <div class="flex items-center mt-4 space-x-4">
            <button
                class="flex-auto text-primary bg-primary-100 border border-primary-100 hover:bg-primary hover:text-white"
                type="button" (click)="closeDialog()" mat-flat-button>
                Cancel
            </button>
            <button class="flex-auto" [color]="'accent'" type="button" (click)="getOTP()"
                [disabled]="accountAvailable?.IsAvailable" mat-flat-button>
                <span *ngIf="!showSpinner">Get OTP</span>
                <mat-spinner *ngIf="showSpinner" diameter="24"></mat-spinner>
            </button>
        </div>
    </div>

    <div *ngIf="showOTPInput">

        <h1 class="text-2xl font-bold pb-8">Insert OTP</h1>

        <p class="pb-8">
            We have sent an OTP (One Time Pin) to your mobile number.
        </p>

        <ng-otp-input class="flex justify-evenly" (onInputChange)="onOtpChange($event)"
            [config]="otpConfig"></ng-otp-input>

        <div class="flex items-center mt-8 space-x-4">
            <button class="flex-auto" type="button" [disabled]="disableReSendOTP" [color]="'primary'" (click)="getOTP()"
                mat-stroked-button>
                {{OTPcountDownActive ? otpTimer : 'Resend OTP'}}
            </button>
            <button class="flex-auto" [color]="'primary'" type="button" (click)="submitOTP()" [disabled]="!otp"
                mat-flat-button>
                Submit & Login
            </button>
        </div>


    </div>
</ng-template>

